import React, { useId } from 'react';

import { Separator } from '../styled';
import TextPrompt from '../text-prompt';
import { FormControlContainer, InputLabelComponent, SelectInput } from './styled';

interface ISelect extends React.ComponentPropsWithoutRef<'select'> {
	label?: string;
	error?: string | undefined;
	isvalid?: boolean;
	optionsdata?: { id: number; label: string; value: string | number }[];
	initoption: { label: string; value: string | number };
	customwidth?: string | number;
	load?: boolean;
}

// eslint-disable-next-line react/display-name
export const TypeSelect = React.forwardRef(({ label, error, isvalid, optionsdata, initoption, load, ...props }: ISelect, ref) => {
	const generatedId = useId();
	const selectId = props.id || props.name || generatedId;
	const errorId = error ? `${selectId}-error` : undefined;

	return (
		<FormControlContainer>
			{label && (
				<InputLabelComponent htmlFor={selectId}>
					{label}
					{props.required && (
						<span
							aria-hidden='true'
							style={{ color: 'var(--color-error)', marginLeft: '4px' }}
						>
							*
						</span>
					)}
					{load && (
						<span
							aria-label='Loading options'
							role='status'
						>
							<i
								className='fa fa-spinner fa-spin ml-3'
								aria-hidden='true'
							/>
						</span>
					)}
				</InputLabelComponent>
			)}
			<SelectInput
				{...props}
				id={selectId}
				iserror={error}
				isvalid={isvalid}
				ref={ref as React.LegacyRef<HTMLSelectElement> | undefined}
				aria-invalid={!!error}
				aria-describedby={errorId}
				aria-required={props.required}
				aria-busy={load}
			>
				<option value={initoption.value}>{initoption.label}</option>
				{optionsdata?.map((i) => (
					<option
						key={i.id}
						value={i.value}
					>
						{i.label}
					</option>
				))}
			</SelectInput>
			{!!error && (
				<>
					<Separator />
					<TextPrompt
						prompt={error}
						status={false}
						id={errorId}
						role='alert'
					/>
				</>
			)}
		</FormControlContainer>
	);
});
